
import React, { useState } from 'react';
import {
  TableBody,
  TableCell,
  TableRow,
} from "@/components/ui/table";
import { TeamRecord } from './types';
import MatchDetails from './MatchDetails';
import { useAuth } from '@/contexts/AuthContext';
import { usePointsDeductions } from '@/hooks/usePointsDeductions';
import { TeamTableRow } from './components/TeamTableRow';

interface TableBodyProps {
  sortedData: TeamRecord[];
  viewType: 'all' | 'home' | 'away';
  getFilteredMatches: (matches: any[], team: string, type: 'wins' | 'draws' | 'losses') => any[];
  data: any[];
  year: string;
  league: string;
}

const LeagueTableBody: React.FC<TableBodyProps> = ({
  sortedData,
  viewType,
  getFilteredMatches,
  data,
  year,
  league
}) => {
  const [selectedStat, setSelectedStat] = useState<{ team: string; type: 'wins' | 'draws' | 'losses' | null }>({ team: '', type: null });
  const [selectedFormMatch, setSelectedFormMatch] = useState<{ team: string; match: any } | null>(null);
  const { isAdmin } = useAuth();
  const { data: pointsDeductions } = usePointsDeductions(year);

  const handleStatClick = (team: string, type: 'wins' | 'draws' | 'losses') => {
    if (selectedStat.team === team && selectedStat.type === type) {
      setSelectedStat({ team: '', type: null });
    } else {
      setSelectedStat({ team, type });
    }
    setSelectedFormMatch(null);
  };

  const handleFormClick = (team: string, match: any) => {
    console.log('Form click - Original match date:', match.Date, 'Type:', typeof match.Date);
    if (selectedFormMatch?.team === team && selectedFormMatch?.match === match) {
      setSelectedFormMatch(null);
    } else {
      setSelectedFormMatch({ team, match });
    }
    setSelectedStat({ team: '', type: null });
  };

  const hasDeduction = (team: string) => {
    return pointsDeductions?.some(deduction => deduction.team === team);
  };

  const filterMatchesByViewType = (matches: any[], team: string) => {
    return matches.filter(match => {
      if (viewType === 'home') {
        return match.HomeTeam === team;
      } else if (viewType === 'away') {
        return match.AwayTeam === team;
      }
      return true;
    });
  };

  return (
    <TableBody>
      {sortedData.map((record, index) => {
        const key = `${record.team}-${index}`;
        return (
          <React.Fragment key={key}>
            <TeamTableRow
              record={record}
              index={index}
              viewType={viewType}
              data={data}
              year={year}
              league={league}
              isAdmin={isAdmin}
              hasDeduction={hasDeduction(record.team)}
              onStatClick={handleStatClick}
              onFormClick={handleFormClick}
            />
            {selectedStat.team === record.team && selectedStat.type && (
              <TableRow>
                <TableCell colSpan={16} className="bg-gray-50">
                  <MatchDetails
                    matches={filterMatchesByViewType(getFilteredMatches(data, record.team, selectedStat.type), record.team)}
                    team={record.team}
                    type={selectedStat.type}
                    onClose={() => setSelectedStat({ team: '', type: null })}
                  />
                </TableCell>
              </TableRow>
            )}
            {selectedFormMatch?.team === record.team && (
              <TableRow>
                <TableCell colSpan={16} className="bg-gray-50">
                  <MatchDetails
                    matches={filterMatchesByViewType([selectedFormMatch.match], record.team)}
                    team={record.team}
                    type="form"
                    onClose={() => setSelectedFormMatch(null)}
                  />
                </TableCell>
              </TableRow>
            )}
          </React.Fragment>
        );
      })}
    </TableBody>
  );
};

export default LeagueTableBody;
